import { Plugin, PluginKey } from 'prosemirror-state';
function requiredNodes(node) {
  let requiredNodes = [];
  node.descendants(child => {
    if (child.attrs.type === 'table' && child.attrs.container) {
      requiredNodes.push(child);
    }
  });
  return requiredNodes;
}

/*
 * returns true if the count of all containers is the same before and after.
 */
function containerCountNotChanged(state, transaction) {
  return requiredNodes(state.doc.content).length === requiredNodes(transaction.doc.content).length;
}

/*
 * returns true if all top level container nodes are valid.
 */
function containerIsValid(transaction) {
  let allRowsValid = true;
  transaction.doc.content.forEach(node => {
    if (!node.attrs.container) {
      return;
    }
    let tableRows = node.content;
    if (tableRows.childCount !== 1) {
      allRowsValid = false;
    }
    let tableCells = tableRows.firstChild?.content;
    if (tableCells?.childCount !== 1) {
      allRowsValid = false;
    }
  });
  return allRowsValid;
}

/*
 * Returns true if all top level nodes are containers with no content blocks outside of them
 * or if there are no containers at all (legacy email templates) or if it already has invalid blocks
 */
function noContentOutsideContainers(transaction, state) {
  let containerCount = 0;
  let newBlockCount = 0;
  let oldBlockCount = 0;
  state.doc.content.forEach(node => {
    if (node.attrs.type !== 'table' && !node.attrs.container) {
      oldBlockCount += 1;
    }
  });
  transaction.doc.content.forEach(node => {
    if (node.attrs.type === 'table' && node.attrs.container) {
      containerCount += 1;
    } else {
      newBlockCount += 1;
    }
  });

  // legacy email templates
  if (containerCount === 0) {
    return true;
  }

  // emails in invalid state, don't allow new blocks to be added outside of container
  if (oldBlockCount > 0) {
    return newBlockCount <= oldBlockCount;
  }

  // valid emails
  return newBlockCount === 0;
}
export function filterContainerDeletion() {
  return new Plugin({
    key: new PluginKey('filterContainerDeletion'),
    filterTransaction: (transaction, state) => {
      return containerCountNotChanged(state, transaction) && containerIsValid(transaction) && noContentOutsideContainers(transaction, state);
    }
  });
}